<template>
  <div class="flex flex-col items- justify-between h-screen">
    <Navbar />
    <div class="py-10">
      <h1 class="text-7xl md:text-[16rem]">404</h1>
      <p class="text-xl">This page could not be found.</p>
      <RouterLink to="/landing" class="text-xl underline mt-8 block">
        Go back to the home page.
      </RouterLink>
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import Navbar from "@/components/navbar/index.vue";
import Footer from "@/components/common/Footer.vue";
import { useHead } from "@vueuse/head";

const headConfig = {
  title: "Page Not Found - Mockey",
  meta: [{ name: "description", content: "Page Not Found - Mockey" }],
};

useHead(headConfig);
</script>
